import { Const } from '../constants/Constants';
import { JuchuShokaiSearchType } from '../objectType/JuchuShokaiSearchType';

export const JuchuShokaiSearchInfo = () => {
  let JuchuShokaiSearchInfo: JuchuShokaiSearchType = {
    tokCd: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.TOKUISAKI_CD) ?? '',
    tokCd2: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.TOKUISAKI_CD2) ?? '',
    nokiKaito: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.NOKI_KAITO) ?? '1',
    dateFrom: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.DATE_FROM) ?? '',
    dateTo: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.DATE_TO) ?? '',
    orderNo: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.ORDER_NO) ?? '',
    shipStatus: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.SHIPSTATUS) ?? '1',
    nouCd: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.NOU_CD) ?? '',
    productCd: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.PRODUCT_CD) ?? '',
    productNm: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.PRODUCT_NM) ?? '',
    color: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.COLOR) ?? '',
    prductHub: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.PRODUCT_HUB) ?? '',
    execute: sessionStorage.getItem(Const.JUCHU_SHOKAI_SEARCH_INFO.EXECUTE) ?? '0',
  };
  return JuchuShokaiSearchInfo;
};
